import anime from 'animejs'

export const AppTimeline = {
	start: function() {
		anime
			.timeline()
			.add({
				targets: '#app',
				opacity: 0,
			})
			.add({
				delay: 3000,
			})
			.add({
				targets: '#app',
				opacity: [0, 1],
				easing: 'easeOutExpo',
				complete: function() {
					let loader = document.getElementById('Loader--App')
					if (loader) loader.remove()
				},
			})
	},
}
